import { Box, Grid, Stack } from "@mui/material";
import AVC_Education_mobile from "../../../pages/education/assets/AVC_Education_mobile.jpg";

const EducationWrapper = ({ children }) => {
  return (
    <Grid
      container
      alignItems="center"
      justifyContent="center"
      sx={{
        flexDirection: {
          xs: "column-reverse", // در موبایل ستونی و برعکس
          sm: "row", // در بقیه سایزها مثل قبل
        },
      }}
    >
      <Grid
        item
        xs={12}
        sm={4}
        position={{ sm: "fixed" }}
        left={{ sm: 0 }}
        top={{ sm: 0 }}
        width="100%"
        height={{ xs: 400, sm: "100%" }}
      >
        {/* MOBILE */}
        <Box
          component="img"
          src={AVC_Education_mobile}
          alt="education"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            display: { xs: "flex", sm: "none" },
          }}
        />
        {/* WEB */}
        <Box
          component="img"
          src="/static/images/AVC_SIGNUP.jpg"
          alt="education"
          sx={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            objectPosition: "center",
            display: { xs: "none", sm: "flex" },
          }}
        />
      </Grid>

      <Grid item xs={12} sm={8} right={{ sm: 0 }} top={{ sm: 0 }} position={{ sm: "absolute" }} width="100%">
        <Stack
          width="100%"
          sx={{ height: { xs: "auto", sm: "100vh" } }}
          py={4}
          justifyContent="flex-start"
          alignItems="center"
        >
          <Stack width="100%" justifyContent="center" alignItems="center">
            {children}
          </Stack>
        </Stack>
      </Grid>
    </Grid>
  );
};

export default EducationWrapper;
